import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Modal, Select, InputNumber, message, Button } from 'antd'
import ChangeOnHoldState from './item-actions/ChangeOnHoldState'
import MarkAsDone from './item-actions/MarkAsDone'
import { saveEmbroideryInfo, getListSku } from "../../../../services/api/3dApi"
import { getLocalData } from '../../../../services/StorageServices'
import { parseJwt } from "../../../../helpers/parseToken"
import _ from "lodash"

class ItemImage extends Component {
    state = {
        visible: false,
        isModalEmbroidery: false,
        loading: false,
        error: '',
        embroideryInfo: [],
        firstEmbroideryPosition : {
            type: "simple",
            name: "",
            stitch_quantity: 0
        },
        embroidery_positions: [],
        firstNamePosition: '',
        errorEmbroideryPosition: ''
    }

    componentDidCatch(error, errorInfo) {
        console.log("ERROR__", error)
        console.log("ERROR__errorInfo", errorInfo)
    }

    componentDidMount() {
        const { embroidery_area_info = {}, meta = {} } = this.props
        const { embroidery_sides = [] } = meta
        if (Object.keys(embroidery_area_info).length > 0) {
            if (Object.keys(embroidery_area_info).some(i => ['embroidery_positions', 'first_embroidery_position'].includes(i))){
                const {embroidery_positions, first_embroidery_position} = Object.assign({}, embroidery_area_info)
                this.setState({
                    firstEmbroideryPosition : first_embroidery_position,
                    embroidery_positions
                })
            }else{
                const embroideryAreaInfo = embroidery_sides.reduce((acc, curr) => {
                    if (!Object.keys(embroidery_area_info).includes(curr)) {
                        acc[curr] = {
                            type: 'simple',
                            embroidery_stitch_quantity: 0
                        }
                        return acc
                    } else {
                        const item = embroidery_area_info[curr] || {}
                        const { type = 'simple', embroidery_stitch_quantity = 0 } = item
                        acc[curr] = {
                            type,
                            embroidery_stitch_quantity
                        }
                        return acc
                    }
                }, {})
                const listEmbroideryInfo = Object.entries(embroideryAreaInfo).map(([key, value]) => ({
                    [key]: value
                }))
                this.setState({
                    embroideryInfo: listEmbroideryInfo
                })
            }
        }else{
            // this.fetchGetFirstEmbroideryPosition()
        }
    }

    fetchGetFirstEmbroideryPosition = async () => {
        try {
            const {productType = '', meta = {}} = this.props
            const { embroidery_sides = [] } = Object.assign({}, meta)
            const {data : res} = await getListSku({sku: [productType]})
            const {data} = Object.assign({}, res)
            const {items} = Object.assign({}, data)

            const {embroidery_info} = !!items && !!items[0] && items[0]
            if(!embroidery_info) return

            const {embroidery_position} = Object.assign({},embroidery_info)
            
            const listEmbroiderySeted = Object.entries(embroidery_position).map(([key, value]) => {
                if(embroidery_sides.includes(key)){
                    return {
                        side: key,
                        order: value.order
                    }
                }
            }).filter(Boolean) || []

            const fisrtEmbroidery = !!listEmbroiderySeted && listEmbroiderySeted.reduce((minItem, currentItem) => {
                return currentItem.order < minItem.order ? currentItem : minItem
            }, listEmbroiderySeted[0])

            this.setState({
                firstNamePosition: (!!fisrtEmbroidery && !!fisrtEmbroidery.side) ? fisrtEmbroidery.side : '',
                errorEmbroideryPosition: (!!fisrtEmbroidery && !!fisrtEmbroidery.side) ? '' : 'Không tìm thấy mặt thêu.',
                embroidery_positions: embroidery_sides
            })
        } catch (error) {
            message.error(error.message)
        }
    }

    _showModal = () => {
        this.setState({
            isModalEmbroidery: true,
        })
    }

    _showModalPreview = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        const {embroidery_area_info = {}} = this.props
        const {firstNamePosition = '', firstEmbroideryPosition} = this.state
        const {first_embroidery_position} = Object.assign({}, embroidery_area_info)

        this.setState({
            isModalEmbroidery: false,
            error: '',
            firstEmbroideryPosition: !!firstNamePosition ? 
            {
                type: "simple",
                name: "",
                stitch_quantity: 0
            } : first_embroidery_position
        })
       
    }

    _hideModalPreview = () => {
        this.setState({
            visible: false,
        })
    }

    _afterDoAction = (status) => {
        this.props.onChangeStatus(status)

        this._hideModalPreview()
    }

    handleChange = (value) => {
        this.setState({
            firstEmbroideryPosition: {
                ...this.state.firstEmbroideryPosition,
                stitch_quantity: +value
            }
        })
    }

    handleSaveInfoEmbroidery = async () => {
        this.setState({
            loading: true
        })

        try {
            const { batchItemId, reloadItems } = this.props
            const {embroidery_positions, firstEmbroideryPosition, firstNamePosition} = this.state

            const newFirstEmbroideryPosition = {
                ...firstEmbroideryPosition,
                type: firstEmbroideryPosition.stitch_quantity >= 25000 ? 'hard' : 'simple'
            }
            const payload = {
                embroidery_positions,
                first_embroidery_position: newFirstEmbroideryPosition
            }

            if(!!firstNamePosition){
                payload.first_embroidery_position = {...newFirstEmbroideryPosition, name: firstNamePosition}
            }else{
                payload.first_embroidery_position = newFirstEmbroideryPosition
            }

            const { data : res } = await saveEmbroideryInfo(batchItemId, payload)
            const { success, error , data } = { ...res }
            if (!success) return message.error(error)

            const {embroidery_area_info} = Object.assign({}, data)
            const {first_embroidery_position} = Object.assign({}, embroidery_area_info)

            this.setState({
                isModalEmbroidery: false,
                error: '',
                firstNamePosition: '',
                firstEmbroideryPosition: first_embroidery_position
            })
            message.success("Lưu thông tin vùng thêu thành công!")
            reloadItems()
        } catch (error) {
            message.error(error.message)
        } finally {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        const role = parseJwt(getLocalData('accessToken')).roles
        const { visible, isModalEmbroidery, error, embroideryInfo, firstEmbroideryPosition, errorEmbroideryPosition, firstNamePosition} = this.state
        const { image, previewImage, type, size, status, orderId, safezoneImage, meta, statusBatch = '' } = this.props
        const { embroidery_sides = [] } = { ...meta }
        const isSupperAdmin = role.length > 0 && role.some(user => user.name === "Super Admin")
        const isAllowEmbroidery = isSupperAdmin || ["pending", "printing"].includes(statusBatch)
        const isAllowSubmit = Array.isArray(embroideryInfo) && embroideryInfo.length > 0
        const isFirstEmbroideryPosition = !!firstEmbroideryPosition && (!!firstEmbroideryPosition.name || !!firstEmbroideryPosition.stitch_quantity)
        const isCMYK = _.get(meta, "infoData.generateOptions.imageOptions.cmyk", false)

        const showSafeZone = (category, dimension) => {
            if (!!safezoneImage) {
                return <img src={safezoneImage} alt="SafeZone" className="Safezone" />
            }
        }

        return (
            <td className='ItemImage d-flex'>
                {
                    previewImage ?
                        <div className='Preview position-relative'>
                            {/* <img src={previewImage} className='position-absolute' alt='preview' /> */}
                            {
                                // showSafeZone(type, size)
                            }

                            <div className='Actions d-flex justify-content-center align-items-center position-absolute' style={{opacity:1, visibility:'visible'}}>
                                <span className='Icon cursor-pointer mr-2' onClick={() => this._showModalPreview()}><Icon
                                    type='eye' /></span>

                                <a href={image} download className='Icon Download'><Icon type="download" /></a>
                            </div>
                            {
                                isCMYK &&
                                <div className='cmyk'>CMYK</div>
                            }
                            {visible &&
                                <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                    onCancel={() => this._hideModalPreview()} className='PrintedFileModal mw-1200'>
                                    <div className="Previewer">
                                        <img src={previewImage} alt='preview' className='d-block m-auto' />
                                        {
                                            showSafeZone(type, size)
                                        }
                                    </div>

                                    <div className='bg-light'>
                                        <div className='OrderActions'>
                                            <div className='Actions'>
                                                {
                                                    'review' === status &&
                                                    <MarkAsDone orderId={orderId} onSuccess={this._afterDoAction} />
                                                }

                                                <ChangeOnHoldState status={status} orderId={orderId}
                                                    onChangeStatus={this._afterDoAction} />
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                            }
                        </div>
                        : image &&
                        <a href={image} target='_blank' rel='noreferrer noopener'
                            className='btn btn-sm text-primary'><u>Download</u></a>
                }
                {
                    embroidery_sides.length > 0 &&
                    <div className="embroidery-area">
                        {
                            embroidery_sides.map((side, index) => {
                                return (
                                    <>
                                        <div key={index} className="embroidery-area-item" onClick={this._showModal}>
                                            {side}
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                }
                <Modal title={`Thông tin vị trí thêu`}
                    visible={isModalEmbroidery}
                    onOk={this.handleSaveInfoEmbroidery}
                    onCancel={() => this._hideModal()}
                    footer={[
                        <Button key="cancel" onClick={() => this._hideModal()}>
                            Cancel
                        </Button>,
                        <Button key="ok" type="primary" onClick={this.handleSaveInfoEmbroidery} disabled={isAllowSubmit || !!errorEmbroideryPosition}>
                            OK
                        </Button>,
                    ]}
                >
                    {
                        isAllowSubmit ? 
                        embroidery_sides.map((sideItem, i) => {
                            const item = embroideryInfo.find(i => i[sideItem]) || {}
                            const { embroidery_stitch_quantity = 0, type: typeEmbroidery = 'simple' } = item[sideItem] || {}
                            return (
                                <div key={`${i}_side`} className={`d-flex align-items-center justify-content-between ${i === embroidery_sides.length - 1 ? '' : 'border-bottom'} pb-2 ${i === 0 ? '' : 'pt-2'}`}>
                                    <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                        <span style={{ textTransform: 'capitalize' }}>{sideItem}</span>
                                    </div>
                                    <div className="type">
                                        <label htmlFor="" style={{ fontWeight: 'bold' }}>Loại</label>
                                        <Select
                                            value={typeEmbroidery || []}
                                            placeholder="Chọn loại"
                                            disabled
                                            style={{
                                                width: 120,
                                            }}
                                            onChange={(value) => this.handleChange(sideItem, 'type', value)}
                                            className='ml-2'
                                        >
                                            <Select.Option value={'simple'}>Đơn giản</Select.Option>
                                            <Select.Option value={'hard'}>Phức tạp</Select.Option>
                                        </Select>
                                    </div>
                                    <div className="quantity">
                                        <label htmlFor="" style={{ fontWeight: 'bold' }}>Số mũi thêu</label>
                                        <InputNumber
                                            value={embroidery_stitch_quantity || 0}
                                            onChange={value => this.handleChange(sideItem, 'embroidery_stitch_quantity', value)}
                                            disabled
                                            className='ml-2'
                                            style={{
                                                width: 120,
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        }) : 
                        <>
                            <div className={`d-flex align-items-center justify-content-between border-bottom pb-3`}>
                                <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                    <span style={{ textTransform: 'capitalize' }}>Tổng Số Vị Trí</span>
                                </div>
                                <div style={{ width: 120 }}></div>
                                <div>
                                    <InputNumber
                                        value={!!embroidery_sides ? embroidery_sides.length : 0}
                                        className='ml-2'
                                        disabled
                                        style={{
                                            width: 120,
                                        }}
                                    />
                                </div>
                            </div>
        
                            <div className={`d-flex align-items-center justify-content-between border-bottom pb-3 pt-2`}>
                                <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                    <div style={{ textTransform: 'capitalize' }}>Mặt Thêu Đầu Tiên</div>
                                    {(isFirstEmbroideryPosition || !!firstNamePosition) && <span className='text-danger font-weight-bold' style={{ textTransform: 'capitalize' }}>{firstEmbroideryPosition.name || firstNamePosition}</span>}
                                </div>
                                <div className="quantity">
                                    <div style={{ fontWeight: 'bold' }}>Số mũi thêu</div>
                                    <InputNumber
                                        value={isFirstEmbroideryPosition ? firstEmbroideryPosition.stitch_quantity : 0}
                                        onChange={this.handleChange}
                                        disabled={!isAllowEmbroidery || !!errorEmbroideryPosition}
                                        className='mt-1'
                                        style={{
                                            width: 120,
                                        }}
                                    />
                                </div>
                                <div className="type">
                                    <div style={{ fontWeight: 'bold' }}>Loại</div>
                                    <Select
                                        value={(isFirstEmbroideryPosition && firstEmbroideryPosition.stitch_quantity >= 25000) ? 'hard' : 'simple'}
                                        placeholder="Chọn loại"
                                        disabled
                                        className='mt-1'
                                        style={{
                                            width: 120,
                                        }}
                                    >
                                        <Select.Option value={'simple'}>Đơn giản</Select.Option>
                                        <Select.Option value={'hard'}>Phức tạp</Select.Option>
                                    </Select>
                                </div>
                            </div>
        
                            <div className={`d-flex align-items-center justify-content-between pb-2 pt-3`}>
                                <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                    <span style={{ textTransform: 'capitalize' }}>Vị Trí Còn Lại</span>
                                </div>
                                <div style={{ width: 120 }}></div>
                                <div>
                                    <InputNumber
                                        value={!!embroidery_sides ? (embroidery_sides.length - 1) : 0}
                                        style={{
                                            width: 120,
                                        }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </>
                    }


                    {!isAllowEmbroidery &&
                        <span className='text-danger'>
                            Chỉ cho phép nhập thông tin thêu khi lô ở trạng thái <span className='font-weight-bold'>"pending", "printing"</span> !
                        </span>}
                    {!!errorEmbroideryPosition && <din className='text-danger font-weight-bold mt-3'>{errorEmbroideryPosition}</din>}
                    {!!error && <span className='text-danger font-weight-bold'>{error}</span>}
                </Modal>
            </td>
        )
    }
}

ItemImage.propTypes = {
    image: PropTypes.string,
    previewImage: PropTypes.string,
    type: PropTypes.string.isRequired,
    size: PropTypes.string,
    safezoneImage: PropTypes.string
}

export default ItemImage
